module.exports = __webpack_public_path__ + "static/media/ball.1a6ab72d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ball.svg
// module id = 25
// module chunks = 0